<template>
  <v-row>
    <v-dialog
      v-model="open"
      transition="scale-transition"
      persistent
      scrollable
      max-width="400px"
    >
      <v-card flat>
        <v-card-title>
          {{ $t("schedule.master_hour_subjects") }}
          <div style="position: absolute; right: 25px;">
            <v-icon @click="close">mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-3">
          <v-data-table
            :headers="tableHeaders"
            :items="dataTable"
            :loading="loading"
            height="600"
            fixed-header
            hide-default-footer
            disable-pagination
            class="elevation-0"
          >
            <template v-slot:item.days="{ item }">
              {{ g_language === "en" ? item.eng : item.ind }}
            </template>
            <template v-slot:item.hour="{ item }">
              <vue-timepicker
                v-model="item.hour"
                :class="g_darkmode ? 'white-text-custom' : ''"
                :minute-interval="5"
                close-on-complete
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-end">
          <v-btn class="mr-2" outlined color="primary" dark @click="close">{{
            $t("app.back")
          }}</v-btn>
          <v-btn
            :loading="loadingSave"
            color="gradient-primary"
            depressed
            dark
            @click="saveLessonHour"
          >
            {{ $t("app.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { getLessonHour, setLessonHour } from "@/api/admin/academic/schedule";
import i18n from "@/i18n";
import { mapGetters } from "vuex";

// CSS vue2-timepicker
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    VueTimepicker: () => import("vue2-timepicker")
  },
  props: {
    open: Boolean,
    close: Function,
    idSchoolYear: Number
  },
  computed: {
    ...mapGetters(["g_language", "g_darkmode"])
  },
  watch: {
    open(newValue) {
      if (newValue) {
        this.listLessonHour();
      } else {
        this.dataTable = [];
      }
    }
  },
  data() {
    return {
      loadingSave: false,
      dataTable: [],
      loading: false,
      tableHeaders: [
        {
          text: i18n.t("schedule.day"),
          sortable: false,
          value: "days",
          width: 90
        },
        {
          text: i18n.t("schedule.duration_subjects"),
          sortable: false,
          value: "hour",
          width: 130
        }
      ]
    };
  },
  methods: {
    snackBar(isError, msg) {
      this.$store.commit("CALL_SNACKBAR", {
        msg: msg,
        color: isError ? "error" : "success"
      });
      this.loadingSave = false;
    },
    async saveLessonHour() {
      this.loadingSave = true;
      await setLessonHour({
        lesson_hour: this.dataTable,
        school_year: this.idSchoolYear
      })
        .then(res => {
          if (res.data.code === 1) {
            this.snackBar(
              false,
              i18n.t("schedule.response.master_hour_subjects.success_edited")
            );
            this.close();
          } else {
            this.snackBar(true, res.data.message);
          }
        })
        .catch(err => {
          this.snackBar(true, err);
        });
      this.loadingSave = false;
    },
    async listLessonHour() {
      this.loading = true;
      await getLessonHour({ school_year: this.idSchoolYear })
        .then(res => {
          if (res.data.code === 1) {
            this.dataTable = res.data.data;
          } else {
            this.snackBar(true, res.data.message);
          }
        })
        .catch(err => {
          this.snackBar(true, err);
        });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.vue__time-picker.white-text-custom {
  input.display-time {
    color: white;
  }
}
</style>
